import { ResponseGatewayPlugin } from "../../../type";
import { isServer } from "../../../utils";
import Cookies from "js-cookie";

const removeGlobalAccountTypePlugin: ResponseGatewayPlugin = {
  name: "removeGlobalAccountTypePlugin",
  type: "response",
  apply(res, options) {
    const isSwitch = Cookies.get("isSwitching");
    if (res.data.code === 401) {
      if (!isSwitch && !isServer()) {
        Cookies.remove("Global-AccountType");
      }
    }
    return res;
  },
};

export default removeGlobalAccountTypePlugin;
